import { useSettings } from 'core/hooks/settings/useSettings'
import { UnitElementsAchDebitPaymentProps } from 'types/unit'

const UnitAchDebit = ({
  'account-id': accountId,
  'customer-token': customerToken,
  fee = 0,
  'is-auto-focus': isAutoFocus = false,
  theme = '',
  language = '',
  'same-day': sameDay = false,
  'show-same-day-selection': showSameDaySelection = false,
  'plaid-account-filters': plaidAccountFilters = ['checking', 'savings'],
  'plaid-link-customization-name': plaidLinkCustomizationName = '',
  'initial-stage-back-button': initialStageBackButton = false,
  'final-stage-done-button': finalStageDoneButton = false,
  'allow-counterparty-delete': allowCounterpartyDelete = false
}: UnitElementsAchDebitPaymentProps) => {
  const { get } = useSettings()
  const mfa = get('mfa')

  return (
    <unit-elements-ach-debit-payment
      account-id={accountId}
      customer-token={customerToken}
      fee={fee}
      is-auto-focus={isAutoFocus}
      theme={theme ? theme : mfa.themes[0]}
      language={language ? language : mfa.language}
      same-day={sameDay}
      show-same-day-selection={showSameDaySelection}
      plaid-account-filters={plaidAccountFilters.join(',')}
      plaid-link-customization-name={plaidLinkCustomizationName}
      initial-stage-back-button={initialStageBackButton}
      final-stage-done-button={finalStageDoneButton}
      allow-counterparty-delete={allowCounterpartyDelete}
    />
  )
}

export default UnitAchDebit
